import { TypeStoreDetail } from "@/lib/redux/features/store/type";

export const checkIfShownStoreName = (store: TypeStoreDetail) => {
  return !(!!store.hidden_store_name || store.platform_name === 'crowdaa')
}